import styled from 'styled-components';
import * as theme from '@zero/design-tokens/build/js/variables';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import React from 'react';



interface PipProps {
    width: number;
}

interface TextProps {
    isSelect: boolean;
    isDisabled?: boolean;
    color: string
}

export const BulletBox = styled.div`
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
    margin-top: -6px;
`

export const BoxPip = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
`;

export const Pip = styled.span<PipProps>`
    width: ${(props) => props.width}px;
    top: 5px;
    display: inline-block;
    height: 14px;
    background-color: var(--friar-gray);
    opacity: 0.6;
`;

export const ExtremePip = styled.span`
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: var(--friar-gray);
    position: absolute;
`

export const TextPip = styled.p<TextProps>`
    position: absolute;
    top: 25px;
    left: -14px;
    width: 50px;
    margin-left: 15px;
    color: ${(props) => props.isSelect ? `${props.color}` : `${theme.ZrColorNeutralMedium02}`}; 
    opacity: ${(props) => props.isDisabled ? '0.5' : '1'};
    font-family: ${theme.ZrFontFamilyDigitalLight};
    font-size: 0.63rem !important;
    font-weight: ${theme.ZrFontWeightBold};
    margin: 0;

    @media (max-width: 530px) { 
        width: 20px;
        line-height: 10px;
        top: 30px;
        left: -7px
    }
`;

export const DivTooltip = styled.div`
    width: 4rem;
    height: 34px;
    position: absolute;
    top: -10px;
    z-index: 100;
`;

export const BoxTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'var(----alabaster)',
        color: 'rgba(0, 0, 0, 0.87)',
        border: '1px solid var(----alabaster)',
    },
}));